import { createQuestionValueMap, mapToTupleArray, PageJson } from "../../../../common/summary-common/applicationSummary";
import { ConfirmationData, updateMapWithFields } from "../../../../common/summary-common/confirmationData";

export const defaultFamilyMedicalHistoryInformation: Map<string, ConfirmationData> = new Map([
    ["f4958067-7ee1-4944-ac32-1692cb4ee1e2", { fontWeight: "bold", }],
    ["0f775e48-c1f9-4249-8f3c-bdc40c9f4718-opt1", { type: "checkbox", }],
    ["0f775e48-c1f9-4249-8f3c-bdc40c9f4718-opt2", { type: "checkbox", }],
    ["0f775e48-c1f9-4249-8f3c-bdc40c9f4718-opt3", { type: "checkbox", }],
    ["0f775e48-c1f9-4249-8f3c-bdc40c9f4718-opt4", { type: "checkbox", }],
    ["0f775e48-c1f9-4249-8f3c-bdc40c9f4718-opt5", { type: "checkbox", }],
    ["0f775e48-c1f9-4249-8f3c-bdc40c9f4718-opt6", { type: "checkbox", }],
    ["0f775e48-c1f9-4249-8f3c-bdc40c9f4718-opt7", { type: "checkbox", showBorder: true }],
]);

export const cerebrovascularDisease: Map<string, ConfirmationData> = new Map([
    ["d46ecb77-b9ea-42db-ae0e-3162a07bbf4b", { fontWeight: "bold", }],
    ["d46ecb77-b9ea-42db-ae0e-3162a07bbf4b|430ad1b5-62fa-4f8e-a44b-d1de944aa31e", {}],
    ["d46ecb77-b9ea-42db-ae0e-3162a07bbf4b|b644fa04-e96f-4761-8553-1c00c7d115c6", { showBorder: true }],
]);

export const coronaryDisease: Map<string, ConfirmationData> = new Map([
    ["e7e94e2e-dea0-4e16-a94f-2d7170da6f8e", { fontWeight: "bold", }],
    ["e7e94e2e-dea0-4e16-a94f-2d7170da6f8e|430ad1b5-62fa-4f8e-a44b-d1de944aa31e", {}],
    ["e7e94e2e-dea0-4e16-a94f-2d7170da6f8e|b644fa04-e96f-4761-8553-1c00c7d115c6", { showBorder: true }],
]);

export const heartDisease: Map<string, ConfirmationData> = new Map([
    ["6dcc2e6b-5b72-4d79-82b3-d19085ab18b0", { fontWeight: "bold", }],
    ["6dcc2e6b-5b72-4d79-82b3-d19085ab18b0|430ad1b5-62fa-4f8e-a44b-d1de944aa31e", {}],
    ["6dcc2e6b-5b72-4d79-82b3-d19085ab18b0|b644fa04-e96f-4761-8553-1c00c7d115c6", { showBorder: true }],
]);

export const diabetesDisease: Map<string, ConfirmationData> = new Map([
    ["ad4ffa8b-c6ca-4080-8417-6565e0bac8ec", { fontWeight: "bold", }],
    ["ad4ffa8b-c6ca-4080-8417-6565e0bac8ec|430ad1b5-62fa-4f8e-a44b-d1de944aa31e", {}],
    ["ad4ffa8b-c6ca-4080-8417-6565e0bac8ec|b644fa04-e96f-4761-8553-1c00c7d115c6", { showBorder: true }],
]);

export const cancerDisease: Map<string, ConfirmationData> = new Map([
    ["e0a1d63b-314f-45e6-9fa5-ae262b74df42", { fontWeight: "bold", }],
    ["e0a1d63b-314f-45e6-9fa5-ae262b74df42|430ad1b5-62fa-4f8e-a44b-d1de944aa31e", {}],
    ["e0a1d63b-314f-45e6-9fa5-ae262b74df42|b644fa04-e96f-4761-8553-1c00c7d115c6", { showBorder: true }],
]);

export const hereditaryDisease: Map<string, ConfirmationData> = new Map([
    ["989493d3-a791-475f-b1ed-959c47d326cd", { fontWeight: "bold", }],
    ["989493d3-a791-475f-b1ed-959c47d326cd|430ad1b5-62fa-4f8e-a44b-d1de944aa31e", {}],
    ["989493d3-a791-475f-b1ed-959c47d326cd|b644fa04-e96f-4761-8553-1c00c7d115c6", { showBorder: true }],
]);

export const updateFamilyMedicalHistoryInformation = (page: PageJson | undefined, cd: Map<string, ConfirmationData>): Map<string, ConfirmationData> => {
    if (page === undefined) {
        return new Map();
    }
    const answersMap = createQuestionValueMap(page);
    if (answersMap.get("0f775e48-c1f9-4249-8f3c-bdc40c9f4718-opt1")?.value === "SI") {
        cd = new Map([
            ...cd,
            ...cerebrovascularDisease,
        ]);
    }

    if (answersMap.get("0f775e48-c1f9-4249-8f3c-bdc40c9f4718-opt2")?.value === "SI") {
        cd = new Map([
            ...cd,
            ...coronaryDisease,
        ]);
    }

    if (answersMap.get("0f775e48-c1f9-4249-8f3c-bdc40c9f4718-opt3")?.value === "SI") {
        cd = new Map([
            ...cd,
            ...heartDisease,
        ]);
    }

    if (answersMap.get("0f775e48-c1f9-4249-8f3c-bdc40c9f4718-opt4")?.value === "SI") {
        cd = new Map([
            ...cd,
            ...diabetesDisease,
        ]);
    }

    if (answersMap.get("0f775e48-c1f9-4249-8f3c-bdc40c9f4718-opt5")?.value === "SI") {
        cd = new Map([
            ...cd,
            ...cancerDisease,
        ]);
    }

    if (answersMap.get("0f775e48-c1f9-4249-8f3c-bdc40c9f4718-opt6")?.value === "SI") {
        cd = new Map([
            ...cd,
            ...hereditaryDisease,
        ]);
    }

    return updateMapWithFields(mapToTupleArray(answersMap), cd);
}